import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus, Trash } from "@phosphor-icons/react";
import { money, computeTotals } from "@/lib/format";

export default function LineItemsEditor({ items, setItems }) {
  const update = (i, field, val) => {
    const next = items.map((it, idx) => (idx === i ? { ...it, [field]: val } : it));
    setItems(next);
  };
  const add = () => setItems([...items, { description: "", quantity: 1, unit_price: 0, taxable: true }]);
  const remove = (i) => setItems(items.filter((_, idx) => idx !== i));
  const t = computeTotals(items);

  return (
    <div className="space-y-3">
      <div className="hidden md:grid grid-cols-[1fr_80px_120px_70px_110px_36px] gap-2 px-1 text-xs uppercase tracking-[0.15em] text-muted-foreground">
        <span>Description</span>
        <span className="text-right">Qté</span>
        <span className="text-right">Prix unit.</span>
        <span className="text-center">Taxe</span>
        <span className="text-right">Montant</span>
        <span></span>
      </div>
      {items.map((it, i) => {
        const amt = (Number(it.quantity) || 0) * (Number(it.unit_price) || 0);
        return (
          <div key={i} className="grid grid-cols-2 md:grid-cols-[1fr_80px_120px_70px_110px_36px] gap-2 items-center">
            <Input
              data-testid={`item-desc-${i}`}
              className="col-span-2 md:col-span-1 rounded-sm"
              placeholder="Description du produit ou service"
              value={it.description}
              onChange={(e) => update(i, "description", e.target.value)}
            />
            <Input
              data-testid={`item-qty-${i}`}
              type="number"
              className="rounded-sm text-right tabular-nums"
              value={it.quantity}
              onChange={(e) => update(i, "quantity", e.target.value)}
            />
            <Input
              data-testid={`item-price-${i}`}
              type="number"
              step="0.01"
              className="rounded-sm text-right tabular-nums"
              value={it.unit_price}
              onChange={(e) => update(i, "unit_price", e.target.value)}
            />
            <div className="flex justify-center">
              <Checkbox
                data-testid={`item-taxable-${i}`}
                checked={it.taxable !== false}
                onCheckedChange={(v) => update(i, "taxable", !!v)}
              />
            </div>
            <div className="text-right tabular-nums text-sm font-medium">{money(amt)}</div>
            <Button
              type="button"
              data-testid={`item-remove-${i}`}
              variant="ghost"
              size="icon"
              className="h-8 w-8 text-muted-foreground hover:text-destructive"
              onClick={() => remove(i)}
            >
              <Trash size={16} />
            </Button>
          </div>
        );
      })}
      <Button type="button" data-testid="add-item-btn" variant="outline" size="sm" className="rounded-sm" onClick={add}>
        <Plus size={16} className="mr-1" /> Ajouter une ligne
      </Button>

      <div className="flex justify-end pt-2">
        <div className="w-full max-w-xs space-y-1.5 text-sm">
          <Row label="Sous-total" value={money(t.subtotal)} />
          <Row label="TPS (5 %)" value={money(t.tps)} />
          <Row label="TVQ (9,975 %)" value={money(t.tvq)} />
          <div className="flex justify-between border-t border-foreground pt-2 mt-1 text-base font-semibold font-heading">
            <span>Total</span>
            <span className="tabular-nums" data-testid="invoice-total-preview">{money(t.total)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between text-muted-foreground">
      <span>{label}</span>
      <span className="tabular-nums">{value}</span>
    </div>
  );
}
